import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';

import type { CommonDateFilter } from '@common/types/filters';

import { AccordionSection } from '@common/components/AccordionSection';
import { CommonDateFilterSection } from '@common/components/FilterGroups/CommonDateFilterSection';

import {
	orderDateCustomRangeAtom,
	orderDateFilterAtom,
	updateOrderDateCustomRangeAtom,
	updateOrderDateFilterAtom,
} from '../../atoms/preordersAtoms';

/**
 * FiltersDrawerOrderDateSection component that provides order date filtering options
 * wrapped in an accordion
 */
export function FiltersDrawerOrderDateSection(): React.JSX.Element {
	const orderDateFilter = useAtomValue(orderDateFilterAtom);
	const setOrderDateFilter = useSetAtom(updateOrderDateFilterAtom);
	const customRange = useAtomValue(orderDateCustomRangeAtom);
	const setCustomRange = useSetAtom(updateOrderDateCustomRangeAtom);

	const handleFilterChange = useCallback(
		(value: CommonDateFilter) => {
			setOrderDateFilter(value);
		},
		[setOrderDateFilter],
	);

	return (
		<AccordionSection title='Deposit date'>
			<CommonDateFilterSection
				filterValue={orderDateFilter}
				onFilterChange={handleFilterChange}
				customRange={customRange}
				onCustomRangeChange={setCustomRange}
			/>
		</AccordionSection>
	);
}
